import { render, staticRenderFns } from "./ProjectDetailOverview.vue?vue&type=template&id=78cbacdd&scoped=true"
import script from "./ProjectDetailOverview.vue?vue&type=script&lang=js"
export * from "./ProjectDetailOverview.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailOverview.vue?vue&type=style&index=0&id=78cbacdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cbacdd",
  null
  
)

export default component.exports